import { useEffect, useRef, useState } from "react";
import SpeechRecognition, {
    useSpeechRecognition,
} from "react-speech-recognition";
import { Modal } from "react-bootstrap";
import { CustomGetAPI } from "../Utils/APIConnector";

const VoiceSearchFeature = ({ show, onHide, filterVenues, CityAreaArray, SportsData, CityName, areaData }) => {
    const {
        transcript,
        listening,
        resetTranscript,
        browserSupportsSpeechRecognition,
    } = useSpeechRecognition();

    const [loader, setLoader] = useState(false);
    const [screens, setScreens] = useState(false);
    // const [blockConfirmButton, setBlockConfirmButtonScreens] = useState(false);
    const [error, setError] = useState("");
    const [userInput, setUserInput] = useState("");
    const [selectedTag, setSelectedTag] = useState("");

    const debounceTimer = useRef(null);
    const lastTranscriptRef = useRef("");

    const normalize = (str) => str?.toLowerCase().replace(/[-\s]/g, "");



    useEffect(() => {
        if (!show) {
            SpeechRecognition.stopListening();
        }
    }, [show]);

    useEffect(() => {
        if (listening && transcript) {
            const newTranscript = transcript;
            const last = lastTranscriptRef.current;

            if (newTranscript.length > last.length) {
                const additional = newTranscript.substring(last.length);
                setUserInput((prev) => (prev + additional).trim());
                lastTranscriptRef.current = newTranscript;
            }
        }
    }, [transcript, listening]);

    // useEffect(() => {
    //     if (!userInput) return;
    //     setBlockConfirmButtonScreens(true);
    //     if (debounceTimer.current) clearTimeout(debounceTimer.current);
    //     debounceTimer.current = setTimeout(() => {
    //         if (lastTranscriptRef.current !== userInput) {
    //             lastTranscriptRef.current = userInput;
    //             fetchWitAI(userInput);
    //         }
    //     }, 2000);
    //     return () => clearTimeout(debounceTimer.current);
    // }, [userInput]);

    const fetchWitAI = async () => {
        try {
            setError("");
            setLoader(true);
            SpeechRecognition.stopListening();

            const res = await fetch("https://api.wit.ai/message?v=20250624&q=" + encodeURIComponent(userInput), {
                headers: {
                    Authorization: "Bearer IZKV3Y4XOWFAHQZDPU7QK7FMB7L2OKUN",
                },
            });

            const data = await res.json();
            const entities = data.entities;

            let matchedSport = "";
            let matchedDate = "";
            let matchedLocation = "";
            let matchedAreaLocation = "";

            const sportEntity = entities["sport:sport"]?.[entities["sport:sport"]?.length - 1];
            if (sportEntity?.value) {
                const possiblePickleBall = entities["sport:sport"]
                    .map((e) => e.body.toLowerCase())
                    .sort()
                    .join(" ");
                if (possiblePickleBall === "ball pickle" || possiblePickleBall === "pickle ball") {
                    matchedSport = "Pickleball";
                } else {
                    matchedSport = sportEntity.value;
                }
            } else {
                matchedSport = "all";
            }

            const locationEntities = entities["wit$location:location"] || [];

            const cityLocation = locationEntities.find((loc) =>
                loc.resolved?.values?.some((v) => v.domain === "locality")
            );

            const areaLocation = locationEntities.find((loc) =>
                !loc.resolved?.values?.some((v) => v.domain === "locality")
            );

            if (cityLocation?.body) {
                const loc = cityLocation.body.toLowerCase();
                const vagueTerms = [
                    "around me", "near me", "nearby", "close to me", "in my area", "close by", "close around", "near here",
                    "somewhere near me", "near my place", "near my location", "near this place", "near my home", "near where i live",
                    "close to where i am", "in this area", "somewhere nearby", "near current location", "close to my area", "near current place"
                ];

                if (vagueTerms.includes(loc)) {
                    const city = await getUserCity();
                    matchedLocation = city || CityName || "";
                } else {
                    matchedLocation = cityLocation.body;
                }
            }

            if (areaLocation?.body) {
                matchedAreaLocation = areaLocation.body;
            }

            if (matchedLocation) {
                if (CityName && CityName.toLowerCase() === matchedLocation.toLowerCase()) {
                    const lastMatchedArea = findLastMatchedArea(userInput, areaData?.map((a) => a.addressline2));
                    if (lastMatchedArea) matchedAreaLocation = lastMatchedArea;
                } else if (matchedLocation) {
                    const response = await CustomGetAPI(
                        `/venue/uniqueaddresses/${matchedLocation}?category=${window.location.pathname?.split("/")[3]}`
                    );
                    const result = JSON.parse(response);
                    if (result?.status === "success") {
                        const newAreaList = result?.data;
                        const lastMatchedArea = findLastMatchedArea(userInput, newAreaList?.map((a) => a.addressline2));
                        if (lastMatchedArea) matchedAreaLocation = lastMatchedArea;
                    }
                }
            }

            const dateEntity = entities["wit$datetime:datetime"]?.[entities["wit$datetime:datetime"]?.length - 1];
            if (dateEntity?.value) {
                matchedDate = dateEntity.value;
            } else if (dateEntity?.from) {
                matchedDate = dateEntity.from.value;
            }

            if (!(matchedSport &&
                (matchedSport.toLowerCase() === "all" ||
                    SportsData.some((sport) => normalize(sport.label) === normalize(matchedSport))))) {
                setError("Sport not recognized. Please try again.");
                return;
            }

            if (!(matchedLocation === "" ||
                CityAreaArray.some(
                    (city) => normalize(city.cityName) === normalize(matchedLocation)
                ))) {
                setError("Location not recognized. Please try again.");
                return;
            }

            filterVenues(matchedDate, null, null, matchedSport, matchedAreaLocation, matchedLocation);

        } catch (error) {
            console.error("❌ Wit.ai fetch error:", error);
        } finally {
            setLoader(false);
        }
    };


    const findLastMatchedArea = (text, areas) => {
        const matched = areas.filter((a) => text.toLowerCase().includes(a?.toLowerCase()));
        return matched.length > 0 ? matched[matched.length - 1] : "";
    };

    const getUserCity = async () => {
        return new Promise((resolve) => {
            if ("geolocation" in navigator) {
                navigator.geolocation.getCurrentPosition(
                    async (position) => {
                        const { latitude, longitude } = position.coords;
                        try {
                            const apiKey = "AIzaSyBeR6pBza9LE_fFj5akK8dbfWxiST2fk38";
                            const res = await fetch(
                                `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`
                            );
                            const data = await res.json();
                            const city = data.results[0].address_components.find((component) =>
                                component.types.includes("administrative_area_level_3")
                            )?.long_name
                            resolve(city);
                        } catch (err) {
                            console.error("Reverse geocoding failed:", err);
                            resolve("");
                        }
                    },
                    async (error) => {
                        console.warn("Geolocation denied or failed:", error.message);
                        resolve("");
                    }
                );
            } else {
                resolve("");
                // resolve(getCityFromIP());
            }
        });
    };

    // const getCityFromIP = async () => {
    //     try {
    //         const res = await fetch("https://ipwho.is/");
    //         const data = await res.json();
    //         return data.success ? data.city : "";
    //     } catch (error) {
    //         console.error("IP location failed:", error);
    //         return "";
    //     }
    // };


    const beepAudio = useRef(null);
    const reverseBeep = useRef(null);

    useEffect(() => {
        beepAudio.current = new Audio("/beep.wav");
        reverseBeep.current = new Audio("/reverse-beep.wav");
        beepAudio.current.load();
        reverseBeep.current.load();
    }, []);

    const startListening = () => {
        playBeep();
        resetTranscript();
        lastTranscriptRef.current = "";
        setScreens(true);
        setTimeout(() => {
            if (browserSupportsSpeechRecognition) {
                SpeechRecognition.startListening({ continuous: true, interimResults: true });
            } else {
                alert("Browser does not support speech recognition.");
            }
        }, 1000);
    };

    const stopListening = () => {
        playReverseBeep();
        SpeechRecognition.stopListening();
    };

    const playBeep = () => {
        if (beepAudio.current) {
            beepAudio.current.currentTime = 0;
            beepAudio.current.play().catch((err) =>
                console.warn("Beep sound failed:", err)
            );
        }
    };

    const playReverseBeep = () => {
        if (reverseBeep.current) {
            reverseBeep.current.currentTime = 0;
            reverseBeep.current.play().catch((err) =>
                console.warn("Reverse beep failed:", err)
            );
        }
    };

    const handleClose = () => {
        SpeechRecognition.stopListening();
        resetTranscript();
        setUserInput("");
        setError("");
        setScreens(false);
        setSelectedTag("");
        onHide();
    };


    const tagList = [
        "Box cricket near me",
        "Box cricket venue in Ahmedabad",
        "Box cricket Mumbai",
        "Box cricket venues available for today 10pm",
    ];

    return (
        <Modal show={show} onHide={handleClose} size="lg" centered>
            <Modal.Body>
                <div className="d-flex justify-content-center align-items-center position-relative">
                    <span style={{ fontWeight: "600" }}>Popular Searches</span>
                    <img src="/images/Closeicon.svg" alt="Closeicon" className="position-absolute end-0" onClick={handleClose} />
                </div>

                <div className="tag-container">
                    {tagList.map((tag, index) => (
                        <div
                            key={index}
                            className={`tag ${selectedTag === tag ? "selected" : ""}`}
                            onClick={() => {
                                setScreens(true);
                                setSelectedTag(tag);
                                setUserInput(tag);
                                // fetchWitAI(tag);
                            }}
                        >
                            {tag}
                        </div>
                    ))}
                </div>

                {!screens ? (
                    <div className="row mt-3 justify-content-center">
                        <button
                            className="col-md-4 col-10 btn btn-primary d-flex justify-content-center align-items-center"
                            onClick={startListening}
                            style={{ background: "#E7666A", border: "#E7666A" }}
                        >
                            <span style={{ fontWeight: "700" }}>Start Voice Search</span>&nbsp;<span style={{ fontWeight: "100" }}>(Beta)</span>
                            &nbsp;  &nbsp;<img src="/images/voice-search-animation.gif" alt="voice-search-animation" className="mic-white" />
                        </button>
                    </div>
                ) : (
                    <>
                        {listening ? (
                            <div className="mb-3 d-flex flex-column align-items-center">
                                <div className="mb-2 mic-text">Listening...</div>
                                <div className="mic-circle" onClick={stopListening}>
                                    <img src="/images/voice-search-animation.gif" alt="voice-search-animation" className="mic-icon" />
                                </div>
                            </div>
                        ) : (
                            <div className="mb-3 d-flex flex-column align-items-center">
                                <div className="mic-circle" onClick={startListening}>
                                    <img src="/images/microphone-recording.png" alt="microphone-recording" className="mic-icon-red" />
                                </div>
                            </div>
                        )}

                        <textarea
                            className="form-control mb-3"
                            value={userInput}
                            onChange={(e) => setUserInput(e.target.value)}
                            placeholder="Start speaking or type here..."
                            style={{ width: "-webkit-fill-available" }}
                        />

                        <div className="row mt-3 justify-content-center">
                            <button
                                className="col-md-3 col-4 btn btn-secondary me-4"
                                style={{ color: "#E7666A", border: "#E7666A", background: "transparent" }}
                                onClick={() => {
                                    // resetTranscript();
                                    setUserInput("");
                                    setError("");
                                    setSelectedTag("");
                                    SpeechRecognition.startListening({ continuous: true, interimResults: true });
                                }}
                            >
                                Reset
                            </button>

                            <button
                                className="col-md-3 col-4 btn btn-primary d-flex justify-content-center align-items-center"
                                onClick={fetchWitAI}
                                style={{ background: "#E7666A", border: "#E7666A" }}
                                disabled={loader || userInput === ""}
                            >
                                Confirm
                                {loader && (
                                    <img height="20px" width="20px" src="/images/loder.svg" style={{ marginLeft: "10px" }} />
                                )}
                            </button>
                        </div>

                        {error && (
                            <div className="text-danger text-center mt-3 fw-bold">
                                {error}
                            </div>
                        )}
                    </>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default VoiceSearchFeature;
